import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "370px",
    maxWidth: "450px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    position: "relative",
  },
  title: {
    color: theme.palette.text.primary,
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "15px",
  },

  cardContentDiv2: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },

  labelText: {
    display: "block",
    borderRadius: "5px",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    textAlign: "center",
  },

  cardContentInput1: {
    padding: "0.2px 6px",
  },

  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    width: "100%",
    textTransform: "none",
    padding: "6px",
    borderRadius: "10px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    marginTop: "5px",
    padding: "5px 0px",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
  defaultButton: {
    color: theme.palette.text.tertiary,
    minWidth: 0,
    padding: "0px",
  },
  selectedButton: {
    color: theme.palette.text.primary,
    minWidth: 0,
    padding: "0px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "0px",
  },
}));

export default useStyles;
